import { render } from "./Password.vue?vue&type=template&id=0c3afb53"
import script from "./Password.vue?vue&type=script&lang=js"
export * from "./Password.vue?vue&type=script&lang=js"

import "./Password.vue?vue&type=style&index=0&id=0c3afb53&lang=stylus"
script.render = render

export default script